import { canManageConductCases, CONDUCT_MANAGE_ROLES } from '@/lib/workforce/phase4-policy-conduct';
import { GRIEVANCE_HANDLER_ROLES } from './grievance-access';
import { RTW_PROVIDER_ROLES } from './return-to-work-access';
import { ADVERSE_ACTION_REVIEWER_ROLES } from './adverse-action-access';

/** Ordered landing and discovery contract for newly admitted host roles.
 * Existing conduct hosts keep all four tabs; each view retains main's gate.
 */
export const CASES_VIEWS = [
  { id: 'grievances', label: 'Grievances', roles: GRIEVANCE_HANDLER_ROLES },
  { id: 'return-to-work', label: 'Return to work', roles: RTW_PROVIDER_ROLES },
  { id: 'approvals', label: 'Action justifications', roles: ADVERSE_ACTION_REVIEWER_ROLES },
  { id: 'pointers', label: 'Case pointers', roles: CONDUCT_MANAGE_ROLES },
] as const;

export const CASES_HOST_ROLES = [...new Set(CASES_VIEWS.flatMap((view) => [...view.roles]))];

export function casesViewsForRole(role: string | null | undefined) {
  const normalizedRole = String(role ?? '').toUpperCase();
  return CASES_VIEWS.filter(
    (view) =>
      canManageConductCases(normalizedRole) ||
      (view.roles as readonly string[]).includes(normalizedRole),
  );
}

export function canOpenCasesView(view: string, role: string | null | undefined) {
  return casesViewsForRole(role).some((entry) => entry.id === view);
}

/** Discovery preserves all legacy host tabs and adds each exported view cohort.
 * Visibility does not replace the controlled reader or the RTW/pointer gate.
 */
export function isCasesHrefVisible(href: string, role: string | null | undefined) {
  const url = new URL(href, 'https://statura.invalid');
  if (url.pathname !== '/people/policies-conduct/cases') return true;
  const view = url.searchParams.get('view');
  return view ? canOpenCasesView(view, role) : casesViewsForRole(role).length > 0;
}
